<template>
  <div>

      <el-row>
        <el-col :span="12">
          <el-card class="box-card">
            <el-row>
              <el-col :span="12">
                <el-input v-model="url" clearable placeholder="请输入tiktok商品url"></el-input>
              </el-col>
              <el-col :span="12">
                <el-button icon="el-icon-search" @click="generate" v-loading.fullscreen.lock="fullscreenLoading"></el-button>
              </el-col>
            </el-row>
            <el-divider></el-divider>
            <el-descriptions class="margin-top" title="截图结果" :column="1"  border >

              <el-descriptions-item>
                <template slot="label">
                  <i class="el-icon-link"></i>
                  图片链接:
                </template>
                {{originUrl}}
              </el-descriptions-item>
            </el-descriptions>
          </el-card>

        </el-col>

      </el-row>
  </div>
</template>
<style>
.text {
  font-size: 14px;
}

.item {
  padding: 18px 0;
}
</style>
<script>
import axios from 'axios'

export default {
  name: "watermarkTools",
  data() {
    return {
      fullscreenLoading: false,
      url: '',
      douyinCode:'',
      originUrl:''
    };
  },
  methods: {
    copyUrl() {
      this.$clipboard(this.uploadedLink)
    },
    generate() {
      const _self = this;
      if(this.url === '') {
        alert('请输入截图url.')
        return;
      }
      this.fullscreenLoading = true;

      axios
          .get("/sf129/screenshot-long-page-s2?url="+encodeURIComponent(this.url))
          .then((content) => {
            console.log(content)
            _self.fullscreenLoading = false;
            _self.originUrl = content.data.url;

          });
    },
  },
  mounted() {
  },
};
</script>
